module.exports = __webpack_public_path__ + "static/img/img8.cf55dff.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qmyd/qgz/img8.jpeg
// module id = FBDp
// module chunks = 46